@if (yield.propertyValue != null && yield.propertyValue !== '') {
  @switch (yield.type) {
    @case (YieldType.Image) {
      <case-image-yield
        [image]="yield.propertyValue"
        [label]="yield.secondPropertyValue"
      ></case-image-yield>
    }
    @case (YieldType.Date) {
      <case-date-yield
      [format]="yield.dateFormat"
      [date]="yield.propertyValue"
      ></case-date-yield>
    }
    @case (YieldType.Datetime) {
      <case-datetime-yield
      [datetime]="yield.propertyValue"
      ></case-datetime-yield>
    }
    @case (YieldType.Currency) {
      <case-currency-yield
      [amount]="yield.propertyValue"
      ></case-currency-yield>
    }
    @case (YieldType.Download) {
      <case-download-yield
      [filePath]="yield.propertyValue"
      ></case-download-yield>
    }
    @case (YieldType.Color) {
      <case-color-yield
      [color]="yield.propertyValue"
      [text]="yield.secondPropertyValue"
      ></case-color-yield>
    }
    @case (YieldType.FileIcon) {
      <case-file-icon-yield
      [path]="yield.propertyValue"
      ></case-file-icon-yield>
    }
    @case (YieldType.Icon) {
      <case-icon-yield
      [icon]="yield.propertyValue"
      ></case-icon-yield>
    }

    @case (YieldType.ProgressBar) {
      <case-progress-bar-yield
      [progressValue]="yield.propertyValue"
      [totalValue]="yield.secondPropertyValue"
      [tooltipText]="yield.thirdPropertyValue"
      ></case-progress-bar-yield>
    }
    @case (YieldType.AnalogProgressBar) {
      <case-analog-progress-bar-yield
      [progressPercentage]="yield.propertyValue"
      ></case-analog-progress-bar-yield>
    }
    @case (YieldType.Switch) {
      <case-switch-yield
      [value]="yield.propertyValue"
      [displayValue]="yield.secondPropertyValue"
      ></case-switch-yield>
    }
    @case (YieldType.Check) {
      <i class="icon icon-check1"></i>
    }

    @case (YieldType.Text) {
      <case-text-yield
      [text]="yield.propertyValue"
      [secondText]="yield.secondPropertyValue"
      ></case-text-yield>
    }
    @default {
      <case-text-yield
      [text]="yield.propertyValue"
      [secondText]="yield.secondPropertyValue"
    ></case-text-yield>
    }
  }
} @else {
  <span>{{ '' | emptyPlaceHolder }}</span>
}

